import { BidIcon, ProfileIcon } from '../icons'
import TypographyParagraph from '../typography/TypographyParagraph'
import Avatar from '../avatars/avatar'
import MetadataEntry from './metadataEntry'
// @ts-ignore
import FallbackAvatar from '#images/avatar11white.png'
import { useTheme } from '#app/utils/providers/themeProvider'
import {
	getUserProfileURL,
	mapIcon,
	truncateStringInMiddle,
	authorProfileUrlFromMetadataEntry,
} from '#app/utils/misc'
import clsx from 'clsx'
import InternalLink from '../common/internalLink'
import { AttestationType } from '#types/loreTypes.tsx'

const Timeline = ({
	isPreview = false,
	metadataEntries = [],
	metadataAdditionalClasses = undefined,
	tweetsUrl = 'https://atomiclore.io/getTweet',
	displayEmbedContent = true,
	displayAvatars = true,
	avatarSize = 'small',
	showVerticalLine = true,
	showDividers = false,
	noContentText = undefined,
	onHighlightAttestation,
	highlightedAttestations = [],
}: {
	isPreview?: boolean
	metadataEntries: AttestationType[]
	metadataAdditionalClasses?: string
	tweetsUrl?: string
	displayEmbedContent?: boolean
	displayAvatars?: boolean
	avatarSize?: 'xxLarge' | 'xLarge' | 'large' | 'medium' | 'small' | 'xSmall'
	showVerticalLine?: boolean
	showDividers?: boolean
	noContentText?: string
	onHighlightAttestation?: (attestationIPFSCID: string, userId: string) => Promise<void>
	highlightedAttestations?: any[]
}) => {
	const [theme] = useTheme()

	return (
		<div className="flex flex-col">
			{metadataEntries.length > 0 ? (
				metadataEntries.map((metadataEntry, index) => (
					<div
						key={`${metadataEntry.references.metadataIPFSCID}-${index}`}
						className={clsx(
							'flex py-4',
							// isPreview ? 'bg-uiPrimaryLight dark:bg-uiPrimaryDark' : '',
							showDividers
								? 'border-b border-textInactiveLight dark:border-uiTertiaryDark'
								: '',
							isPreview
								? 'rounded-xl border border-uiSecondaryLight bg-light dark:border-uiSecondaryDark dark:bg-dark'
								: '',
						)}
					>
						<div
							className={
								'ml-4 flex min-w-10 flex-col items-center justify-start'
							}
						>
							{displayAvatars ? (
								<InternalLink
									to={authorProfileUrlFromMetadataEntry(metadataEntry) || ''}
								>
									<Avatar
										avatar={{
											src: metadataEntry.artistAvatar
												? metadataEntry.artistAvatar
												: metadataEntry.userAvatar
													? metadataEntry.userAvatar
													: FallbackAvatar,
											name:
												metadataEntry.artistName ||
												metadataEntry.username ||
												(metadataEntry.address &&
													metadataEntry.address.includes('.eth'))
													? metadataEntry.address
													: truncateStringInMiddle(metadataEntry.address),
										}}
										size={avatarSize}
										isVerified={true}
										additionalClasses="pb-2 md:pb-2"
									/>
								</InternalLink>
							) : (
								<div className="mt-2 pb-2 text-textPrimaryLight dark:text-textPrimaryDark">
									{mapIcon(
										metadataEntry.template.slug,
										'large',
										metadataEntry.properties?.fileType || '',
									)}
								</div>
							)}
							{showVerticalLine && (
								<div className="h-full border-l border-textInactiveLight dark:border-textInactiveDark"></div>
							)}
						</div>
						<div className="mr-4 min-w-0 flex-1">
							<MetadataEntry
								isPreview={isPreview}
								metadata={metadataEntry}
								additionalClasses={metadataAdditionalClasses}
								tweetsUrl={tweetsUrl}
								displayEmbedContent={displayEmbedContent}
								displayIcon={displayAvatars}
								nftName={metadataEntry.nftName}
								collectionName={metadataEntry.collectionName}
								userProfileUrl={
									authorProfileUrlFromMetadataEntry(metadataEntry) || ''
								}
								theme={theme}
								onHighlightAttestation={onHighlightAttestation}
								highlightedAttestations={highlightedAttestations}
							/>
						</div>
					</div>
				))
			) : (
				<div
					className={clsx(
						'flex rounded-2xl p-4',
						isPreview ? 'bg-uiPrimaryLight dark:bg-uiPrimaryDark' : '',
					)}
				>
					<div className="flex w-10 flex-grow flex-col items-center justify-start">
						<div className="mb-2 flex h-10 w-10 items-center justify-center text-textInactiveLight dark:text-textInactiveDark sm:w-5">
							<ProfileIcon />
						</div>
						<div className="h-full border-l border-textInactiveLight dark:border-textInactiveDark"></div>
					</div>
					<div className="flex w-full">
						<div className="mr-1 flex h-full w-5 items-start justify-center">
							<BidIcon />
						</div>
						<div className="flex flex-col gap-y-1">
							<div className="text-textSecondaryLight dark:text-textSecondaryDark">
								<TypographyParagraph size="medium">
									{noContentText
										? noContentText
										: 'No history has been signed yet for this year. Tap "Sign" to add onchain lore.'}
								</TypographyParagraph>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default Timeline
